import { FC } from 'react';

import Icon from './image.svg';

export const MetamaskLogo: FC = () => <img src={Icon} alt="metamask logo" />;
